module.exports = __webpack_public_path__ + "img/E@2x.332de1c.jpg";